import { Component } from 'src/utils';
import template from './reset-password.html';
import resetPwdImg from './../../../images/reset-pass-1.png';


@Component({
  controllerAs: 'resetPwd',
  template
})

export default class ResetPasswordContainer {
  static $inject = [
    '$state',
    '$stateParams',
    'authService'
  ];

  constructor($state, $stateParams, authService) {
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.authService = authService;
    this.resetPwdImg = resetPwdImg;
  }

  submit(form) {
    if (form.$invalid) {
      return;
    }
    form.error = {};
    if (this.password === this.confirmPassword) {
      this.authService.resetPassword({
        password: this.password,
        id: this.$stateParams.id,
        token: this.$stateParams.token
      })
        .then(() => this.$state.go('category', {storeName: this.$stateParams.storeName}))
        .catch(err => form.error = err.data);
    }
    else {
      form.error.message = 'Password mismatch';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/reset-password/reset-password.js